<template>
    <div class="noflex">


        <a v-if="! statusOpen" v-on:click="showmodal=true">Show Hot Lunch </a>

        <div v-if="showmodal">

            <span v-if="! statusOpen" v-on:click="close">Close</span>
            <ul class="subblock-list">
                <li v-if="options.length > 1">
                    <label v-on:click="!modeAll ? modeAll = true : modeAll = false;  checkAll()  " >
                        <span v-bind:class="[modeAll? 'checkbox checked' : 'checkbox' ]"></span>
                        <span v-if="labelAllDaysWithoutWe">{{ trans.global.fourdays[lang] }}</span>
                        <span v-else>{{ trans.global.alldays[lang] }}</span>
                    </label>
                    <span>
                        {{ trans.global.chf_month[lang] }}<br>
                        8.1% {{ trans.global.mwst[lang] }}
                    </span>
                    <em>{{ priceAllDays | francsNetto}} <br> <span>{{ priceAllDaysNetto | francsVat}}</span></em>
                </li>
                <li v-if="!noindividual">
                    <label v-on:click="!modeIndividual ? modeIndividual = true : modeIndividual = false; checkIndividual()" v-if="options.length > 1">
                        <span v-bind:class="[modeIndividual? 'checkbox checked' : 'checkbox' ]"></span>
                        <i v-if="onlyDiDo"> {{ trans.global.twodays[lang] }} </i>
                        <i v-else>  {{ trans.global.individual_days[lang] }} </i>
                    </label>
                     <span>
                          {{ trans.global.chf_month[lang] }}<br>
                         8.1%  {{ trans.global.mwst[lang] }}
                    </span>
                     <em v-if="modeIndividual">{{ priceTotal | francs }}<br><span>{{ priceTotal | francsVat }}</span></em>
                     <em v-else>
                         <i v-if="!onlyDiDo">{{ 0 | francs }} </i>
                         <i v-else>{{ priceDiDo | francs }}</i>
                         <br><span>{{ 0 | francsVat }}</span>
                    </em>
                    <div v-if="(modeIndividual || options.length==1) && !onlyDiDo" class="noflex weekdays-wrapper">
                        <h5>
                            {{ trans.global.choose_hotlunchdays[lang] }}</h5>
                        <span
                            v-for="(weekday,index) in weekdays"
                            :key="index"
                            v-bind:class="[weekday.isActive ? 'pill active' : 'pill' ,'c'+index ]"
                            v-on:click="toggleWeekday(index)"
                        >
                        <i v-if="options.length > 1">{{ weekday.label }}</i>
                        <i v-else>ja</i>
                        </span>
                    </div>
                </li>
            </ul>
            <!-- <h3 v-if="options.length > 1">Preis: {{ priceTotal }}</h3>
            <h3 v-else>Preis: {{ priceShownDays }}</h3> -->
        </div>
    </div>

</template>



<script>

    import * as helpers from "./helpers.js";

    export default {

        data: function() {
            return  {
                showmodal: false,
                weekdays: false,
                allselections: [],
                modeIndividual: false,
                modeAll: false
            }
        },
        props: {
            options: {
                type: Array,
                required: true
            },
            service: {
                type: Object,
                required: true
            },

            selections: {
                type: Array,
                required: true
            },
            location: {
                type: Number,
                required: true
            },
            session: {
                type: String,
                required: true
            },
            statusOpen: {
                type: Boolean,
                required: true
            },

            onlyDiDo: {
                type: Boolean,
                required: true
            },
            trans: '',
            lang: '',
            labelAllDaysWithoutWe: false,
            noindividual: false
        },
        watch: {
            allselections: function()
            {
                 this.$emit('submited', this.lunchSelections, this.options.length,this.options[0].id);
            },
            options: function()
            {
                 this.weekdays = this.options;
            }
        },
        computed: {
           priceAllDays: function()
            {
                return this.service.relevantPrice.price_brutto * this.weekdays.length
            },
            priceAllDaysNetto: function()
            {
                return this.service.relevantPrice.price * this.weekdays.length
            },
             priceDiDo: function()
            {
                return this.service.relevantPrice.price * 2
            },
            lunchSelections: function()
            {
                let service = this.service;
                var selections = this.allselections.filter(function(item) {
                    return item.service_id == service.id;
                });
                return selections;
            },
            priceTotal: function()
            {
                var price = 0;
                for(var i= 0; i < this.lunchSelections.length; i++)
                {
                    price = price + this.lunchSelections[i].service.relevantPrice.price;
                }
                if(!this.modeAll && !this.modeIndividual){
                    price = 0;
                }
                return price;
            },
            priceShownDays: function()
            {
                var price = 0;
                for(var i = 0; i < this.options.length; i++)
                {
                    for(var k = 0; k < this.lunchSelections.length; k++)
                    {
                        if(this.lunchSelections[k].timetables[0].weekday == this.options[i].id)
                        {
                            price =  this.lunchSelections[k].service.relevantPrice.price_brutto;
                        }
                    }
                }
                return price;
            },

        },
        mounted() {
            this.mount();
        },
        methods: {
            mount(){
                this.weekdays = this.options;
                if(this.statusOpen)
                {
                    this.showmodal = true;
                }
                this.allselections = JSON.parse(JSON.stringify(this.selections));
                this.setWeekdaysUi();

                if(this.lunchSelections.length > 0 && this.lunchSelections.length != this.weekdays.length)
                {
                    this.modeIndividual = true;
                }
                if(this.lunchSelections.length == this.weekdays.length)
                {
                    this.modeAll = true;
                }
            },

            checkIndividual: function()
            {
                let app = this;
                app.deleteAllDays(); // reset selection
                app.modeAll = false;

                if(app.onlyDiDo)
                {
                     for (var i = 0; i < app.weekdays.length; i++) {
                        var day = this.lunchSelections.filter(function(item) {
                            return item.timetables[0].weekday == app.weekdays[i].id;
                        });
                        if(day.length == 0 && (app.weekdays[i].id == 'di' || app.weekdays[i].id == 'do'))
                        {
                            app.addNewSelection(i);
                        }
                    }
                }

            },
            checkAll: function()
            {
                let app = this;
                app.modeIndividual = false;
                if(app.modeAll){
                    app.selectAllDays();
                }else{
                    app.deleteAllDays();
                }
            },
            close: function()
            {
                this.showmodal = false;
            },
            setWeekdaysUi: function()
            {
                let app = this;
                for (var i = 0; i < app.weekdays.length; i++ ) {
                    var day = this.lunchSelections.filter( function(item) {
                        return item.timetables[0].weekday == app.weekdays[i].id;
                    });
                    if( day.length > 0 )
                    {
                        this.weekdays[i].isActive = true;
                    }
                }
            },
            checkSelection(){
                let app = this;
                for (var q = 0; q < app.weekdays.length; q++) {
                    var hasActive = app.lunchSelections.filter(function(item) {
                        return item.timetables[0].weekday == app.weekdays[q].id;
                    });
                    if(hasActive[0]){
                         app.weekdays[q].isActive = true;
                    }
                }
            },
            toggleWeekday: function(index)
            {

                let app = this;

                if(app.weekdays[index].isActive == undefined || app.weekdays[index].isActive === false){
                    var newstatus = 1;
                }else{
                     var newstatus = 0;
                }



                // let status = app.weekdays[index].isActive = app.weekdays[index].isActive == undefined || app.weekdays[index].isActive == false;

                if(newstatus == 1){
                    app.weekdays[index].isActive = true;
                }else{
                    app.weekdays[index].isActive = false;
                }


                // set selection
                var day = this.lunchSelections.filter(function(item) {
                    return item.timetables[0].weekday == app.weekdays[index].id;
                });

                if(newstatus==1)
                {
                    //  $(".c"+index).addClass("active");
                    if(day.length == 0)
                    {
                         this.addNewSelection(index);
                    }
                }
                else
                {
                    for (var i = 0; i < app.allselections.length; i++) {
                       if(day[0].id == app.allselections[i].id)
                       {
                           app.allselections.splice(i, 1);
                       }
                    }
                }


                setTimeout(function() {
                    app.checkSelection()
                }, 50);

                this.$forceUpdate();

            },
            selectAllDays: function()
            {
                let app = this;

                for (var i = 0; i < app.weekdays.length; i++) {
                    var day = this.lunchSelections.filter(function(item) {
                        return item.timetables[0].weekday == app.weekdays[i].id;
                    });

                    if(day.length == 0)
                    {
                        app.addNewSelection(i);
                    }
                }
            },

            deleteAllDays: function()
            {
                let app = this;
                for (var i = app.allselections.length - 1; i >=0; i--) {
                    if(app.allselections[i].service_id == app.service.id)
                    {
                        app.allselections.splice(i, 1);
                    }
                }
                for (var i = 0; i < app.weekdays.length; i++) {
                    app.weekdays[i].isActive = false;
                }
            },

            addNewSelection: function(weekdayId)
            {
                let app = this;
                let timetables = [];
                let id = app.generateString(12);
                timetables[0] = {
                    id: app.generateString(12),
                    weekday: app.weekdays[weekdayId].id,
                    selection_id: id,
                }
                app.allselections.push(
                    {
                        id: id,
                        service_id: app.$props.service.id,
                        service: app.$props.service,
                        location_id: app.$props.location,
                        timetables: timetables,
                        session_id: app.session
                    }
                );
                app.weekdays[weekdayId].isActive = true;

            },
            ...helpers

        }

    }
</script>
